import { useEffect, useState } from 'react';
import useMeasure from 'react-use-measure';

import { setTileAnimationSteps } from '@/redux/reducers/diceGameReducer';
import { useAppDispatch } from '@/redux/store';

interface UseDiceBoardSizeReturnType {
  diceBoardRef: ReturnType<typeof useMeasure>[0];
  oneCellSize: number;
}

const useDiceBoardSize = (): UseDiceBoardSizeReturnType => {
  const [diceBoardRef, measure] = useMeasure();
  const [oneCellSize, setOneCellSize] = useState(0);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!measure.width) return;
    const step = (measure.width - 10) / 6; // including 2px gap

    setOneCellSize(step);

    const getStep = (i: number): number => step * i + 2 * i;

    const tileAnimationSteps = [
      [0, 0],
      [getStep(1), 0],
      [getStep(2), 0],
      [getStep(3), 0],
      [getStep(4), 0],
      [getStep(5), 0],
      [getStep(5), getStep(1)],
      [getStep(5), getStep(2)],
      [getStep(5), getStep(3)],
      [getStep(5), getStep(4)],
      [getStep(5), getStep(5)],
      [getStep(4), getStep(5)],
      [getStep(3), getStep(5)],
      [getStep(2), getStep(5)],
      [getStep(1), getStep(5)],
      [0, getStep(5)],
      [0, getStep(4)],
      [0, getStep(3)],
      [0, getStep(2)],
      [0, getStep(1)],
    ];
    dispatch(setTileAnimationSteps(tileAnimationSteps));
  }, [measure]);

  return { diceBoardRef, oneCellSize };
};

export { useDiceBoardSize };
